import React from 'react';

const Section1 = () => {
    return (
    <div className='bg-blue-200 '>

<div className="hero my-10 pb-9">
        <div className="hero-content flex-col lg:flex-row">
            <div className=' relative sm:w-1/2 w-1/2'>
            <img src="https://tkpro-demo2.envalab.com/14/wp-content/uploads/sites/15/2022/03/number-12-illuminated-in-highrise-seattle-washin-2022-03-04-02-39-21-utc.jpg" alt='' className=" w-3/4 h-full rounded-lg shadow-2xl" />
            <img src= "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS-R5FCD_gwK86nxlqua4of0LUgI_JJ5viKlw&usqp=CAU" alt='' className=" absolute right-5 w-3/5  border-spacing-8 top-1/2  rounded-lg shadow-2xl" />
            </div>
           <div className='w-1/2 sm:w-1/2'>
          
            <h1 className="text-5xl font-bold my-5 mt-4 ">
            Welcome to Liverpool  Britain in 2023.<br/>
       
            </h1>
            <p className="py-6">
            Liverpool welcomes a musical extravaganza like no other and a king prepares for a new era.
           Expect inventive new experiences and captivating stories, brought together with a dose of British flair. </p>

           <br/>
                   <p>
                   From pioneering cultural spaces and urban havens to countryside trails and relaxing wellness retreats, its all happening on our shores and youre invited! </p>
            <button className="btn mt-10 btn-primary">Get Started</button>
          </div>
        </div>
      </div>





  {/* <div className="bg-blue-400 ">
  <div className="hero-content flex-col lg:flex-row">
    <img src="https://www.visitbritain.com/sites/cms/files/styles/media_component_3_4_xl/public/lookatmedam/603062l5.jpg.webp?h=05ee7ac3&itok=6aVOFpA-" className="max-w-sm rounded-lg h-[400px] shadow-2xl" alt='' />
    <div className='ml-9'>
      <h1 className="text-2xl font-bold">Welcome to Liverpool  Britain in 2023.</h1>
      <p className="py-6   text-justify">Liverpool welcomes a musical extravaganza like no other and a king prepares for a new era.
           Expect inventive new experiences and captivating stories, brought together with a dose of British flair. From pioneering cultural spaces and urban havens to countryside trails and relaxing wellness retreats, its all happening on our shores and youre invited!</p>
      <button className="btn btn-primary">more...</button>
    </div>
  </div>
</div>  */}
        </div>
    );
};

export default Section1;